{
  "subjects": {
    "mathematics": "Matemática",
    "science": "Ciências",
    "english": "Inglês",
    "history": "História",
    "geography": "Geografia",
    "arts": "Artes",
    "music": "Música",
    "physicalEducation": "Educação Física",
    "computerScience": "Informática"
  },
  "grades": {
    "kindergarten": "Jardim de Infância",
    "elementary": "Fundamental I",
    "middle": "Fundamental II",
    "high": "Ensino Médio",
    "grade": "{{number}}º Ano"
  },
  "lesson": {
    "title": "Aula",
    "objectives": "Objetivos de Aprendizagem",
    "duration": "Duração",
    "difficulty": "Dificuldade",
    "prerequisites": "Pré-requisitos",
    "materials": "Materiais",
    "instructions": "Instruções",
    "activities": "Atividades",
    "assessment": "Avaliação",
    "complete": "Concluir Aula",
    "next": "Próxima Aula",
    "previous": "Aula Anterior"
  },
  "assessment": {
    "title": "Avaliação",
    "type": {
      "quiz": "Questionário",
      "test": "Prova",
      "homework": "Tarefa de Casa",
      "project": "Projeto",
      "presentation": "Apresentação"
    },
    "status": {
      "notStarted": "Não Iniciado",
      "inProgress": "Em Andamento",
      "submitted": "Enviado",
      "graded": "Corrigido",
      "returned": "Devolvido"
    },
    "score": "Pontuação",
    "grade": "Nota",
    "feedback": "Feedback",
    "attempts": "Tentativas",
    "timeLimit": "Limite de Tempo",
    "submit": "Enviar Avaliação",
    "save": "Salvar Progresso"
  },
  "progress": {
    "title": "Progresso",
    "overall": "Progresso Geral",
    "weekly": "Progresso Semanal",
    "monthly": "Progresso Mensal",
    "completed": "Concluído",
    "inProgress": "Em Andamento",
    "notStarted": "Não Iniciado",
    "streak": "Sequência de Aprendizado",
    "achievements": "Conquistas",
    "certificates": "Certificados"
  }
}
